import React from "react";
import "../css/overlay.css";

interface MainContainerProps {
  children: React.ReactNode;
  className?: string;
}

export const OverlayWindow: React.FC<MainContainerProps> = ({
  children,
  className,
}) => {
  return <div className={"overlay" + " " + className}>{children}</div>;
};
